export enum SourceSchemaFieldType {
  NOT_SET = 'SSFT_NOT_SET',
  STRING = 'SSFT_STRING',
  INTEGER = 'SSFT_INTEGER',
  DECIMAL = 'SSFT_DECIMAL',
  BOOLEAN = 'SSFT_BOOLEAN'
}

export enum DestinationSchemaFieldType {
  NOT_SET = 'DSFT_NOT_SET',
  STRING = 'DSFT_STRING',
  INTEGER = 'DSFT_INTEGER',
  DECIMAL = 'DSFT_DECIMAL',
  BOOLEAN = 'DSFT_BOOLEAN'
}

export enum BaseContractFieldType {
  NOT_SET = 'CBCFT_NOT_SET',
  STRING = 'CBCFT_STRING',
  INTEGER = 'CBCFT_INTEGER',
  DECIMAL = 'CBCFT_DECIMAL',
  BOOLEAN = 'CBCFT_BOOLEAN'
}

export interface SchemaFieldObjectType {
  fields: SchemaField[];
}

export interface SchemaFieldArrayType {
  primitive_type?: SourceSchemaFieldType | DestinationSchemaFieldType;
  object_schema?: SchemaFieldObjectType;
}

export interface SchemaField {
  id: string;
  display_name: string;
  description: string;
  required: boolean;
  primitive_type?: SourceSchemaFieldType | DestinationSchemaFieldType;
  object_schema?: SchemaFieldObjectType;
  array?: SchemaFieldArrayType;
}

export interface LocaleConfig {
  supported_locales: string[];
}

export interface Schema {
  id: string;
  display_name: string;
  fields: SchemaField[];
  /**
   * Optional. Present when the source schema declared `localeConfig.supportedLocales`.
   * Gates the language filter dropdown.
   */
  locale_config?: LocaleConfig;
}

export interface CGDestinationSchema extends Schema {
  cg_metadata?: CGSchemaMetadata;
}

export interface CGSchemaMetadata {
  source_product: string;
  source_object_name: string;
  created_by: string;
}

export interface DestinationSchemaItem {
  id: string;
  display_name: string;
}

export interface GetSchemaResponse {
  schema: Schema;
}

export interface GetCGDestinationSchemaResponse {
  schema: CGDestinationSchema;
}

export interface ListDestinationSchemasResponse {
  schemas: DestinationSchemaItem[];
}

export interface SourceSchemaItem {
  id: string;
  display_name: string;
  disabled: boolean;
  warning: string;
}

export interface ListSourceSchemasResponse {
  schemas: SourceSchemaItem[];
}

export interface GetSourceSchemaResponse {
  schema: Schema;
}
